import { httpClient } from './httpClient';

export interface Setting {
  id?: number;
  key: string;
  value: string;
  isDefault?: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface TicketTitleSuggestionsSettings {
  enabled: boolean;
}

export const settingsService = {
  /**
   * Get a setting by key
   */
  getSetting: async (key: string): Promise<Setting | null> => {
    try {
      return await httpClient.get<Setting>(`/api/settings/${key}`);
    } catch (error) {
      console.error('Error fetching setting:', error);
      return null;
    }
  },

  /**
   * Save or update a setting
   */
  saveSetting: async (key: string, value: string): Promise<Setting | null> => {
    try {
      return await httpClient.put<Setting>(`/api/settings/${key}`, { value });
    } catch (error) {
      console.error('Error saving setting:', error);
      return null;
    }
  },

  /**
   * Get ticket title suggestions enabled setting
   */
  getTicketTitleSuggestionsEnabled: async (): Promise<boolean> => {
    try {
      const response = await httpClient.get<TicketTitleSuggestionsSettings>(
        '/api/settings/ticket-title-suggestions/enabled'
      );
      return response?.enabled ?? false;
    } catch (error) {
      console.error('Error fetching ticket title suggestions setting:', error);
      return false;
    }
  },

  /**
   * Set ticket title suggestions enabled setting
   */
  setTicketTitleSuggestionsEnabled: async (enabled: boolean): Promise<boolean> => {
    try {
      await httpClient.put('/api/settings/ticket-title-suggestions/enabled', { enabled });
      return true;
    } catch (error) {
      console.error('Error updating ticket title suggestions setting:', error);
      return false;
    }
  },

  /**
   * Get auto-title enabled setting
   */
  getAutoTitleEnabled: async (): Promise<boolean> => {
    try {
      const response = await httpClient.get<{ enabled: boolean }>(
        '/api/settings/auto-title/enabled'
      );
      return response?.enabled ?? false;
    } catch (error) {
      console.error('Error fetching auto-title setting:', error);
      return false;
    }
  },

  /**
   * Set auto-title enabled setting
   */
  setAutoTitleEnabled: async (enabled: boolean): Promise<boolean> => {
    try {
      await httpClient.put('/api/settings/auto-title/enabled', { enabled });
      return true;
    } catch (error) {
      console.error('Error updating auto-title setting:', error);
      return false;
    }
  }
};
